const intialState = {
    id:'',
    nom:'',
    email:'',
    tel:'',
    adresse:'',
    ville:'',
    cp:'',
    siret:'',
    salaries_max:'',
    salaries_ajoutes:'',
    date_inscription:'',
    logoRandomToken: '123',
    salaries:[]
};

export default function reducer(state=intialState, action){

    switch (action.type){

        case "GET_ENTREPRISE_INFO_FULFILLED":{
            return {
                ...state, ...action.payload.data
            }
        }

        case "SET_ENTREPRISE_INFO":{
            return {
                ...action.payload.data
            }
        }
        case "GENERATE_RANDOM_LOGO_TOKEN":{
            return {
                ...state,
                logoRandomToken:action.payload
            }
        }
        case "GET_ENTREPRISE_SALARIES_FULFILLED":{
            return { ...state,
                salaries :action.payload.data
            }
        }

        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/entreprise/infos.js